/**
 * Snapshot of what the next stack may send right now.
 * Legacy pages set `stack: 'legacy'`, which leaves today's sinks unchanged.
 * The default is closed so a next-stack page cannot emit before the provider runs.
 */

export type ConsentGateState = {
  stack: 'next' | 'legacy';
  stats: boolean;
  analytics: boolean;
  ads: boolean;
  gtm: boolean;
  replay: boolean;
};

const CLOSED: ConsentGateState = {
  stack: 'next',
  stats: false,
  analytics: false,
  ads: false,
  gtm: false,
  replay: false,
};

let gate: ConsentGateState = CLOSED;

export function setConsentGate(next: ConsentGateState): void {
  gate = next;
}

export function getConsentGate(): ConsentGateState {
  return gate;
}

export function allowsStats(): boolean {
  return gate.stack === 'legacy' || gate.stats;
}

export function allowsDataLayer(): boolean {
  return gate.stack === 'legacy' || gate.gtm;
}

export function allowsAds(): boolean {
  return gate.stack === 'legacy' || gate.ads;
}
